import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

const GlobalizationMenu = ({ isPlatformAdmin, ...other }: $TSFixMe) =>
    isPlatformAdmin ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Configuration} />}
            primaryText={<LocalizedText textKey={TextKey.Globalization} />}
            {...other}
        >
            {createListItemWithLink({
                textKey: TextKey.CurrencyPlural,
                iconName: IconName.PaymentReport,
                path: 'Globalization/Currencies',
            })}
            {createListItemWithLink({
                textKey: TextKey.LanguagePlural,
                iconName: IconName.Languages,
                path: 'Globalization/Languages',
            })}
            {createListItemWithLink({
                textKey: TextKey.CulturePlural,
                iconName: IconName.Cultures,
                path: 'Globalization/Cultures',
            })}
            {createListItemWithLink({
                textKey: TextKey.LegalEnvironmentPlural,
                iconName: IconName.LegalEnvironments,
                path: 'Globalization/LegalEnvironments',
            })}
            {createListItemWithLink({
                textKey: TextKey.TaxEnvironmentPlural,
                iconName: IconName.TaxEnvironment,
                path: 'Globalization/TaxEnvironments',
            })}
            {createListItemWithLink({
                textKey: TextKey.CityTaxPlural,
                iconName: IconName.PaymentReport,
                path: 'Globalization/CityTaxes',
            })}
            {createListItemWithLink({
                textKey: TextKey.CountryPlural,
                iconName: IconName.Countries,
                path: 'Globalization/Countries',
            })}
            {createListItemWithLink({
                textKey: TextKey.TimeZonePlural,
                iconName: IconName.Time,
                path: 'Globalization/TimeZones',
            })}
            {createListItemWithLink({
                textKey: TextKey.VirtualCardHolders,
                iconName: IconName.Preauthorization,
                path: 'Globalization/VirtualCardHolders',
            })}
        </SidebarExpandableListItem>
    ) : null;

export default connect(
    createStructuredSelector({
        isPlatformAdmin: isCurrentProfilePlatformAdmin,
    })
)(GlobalizationMenu);
